module.exports = __webpack_public_path__ + "static/media/x_active2.6520c039.svg";